module.exports = __webpack_public_path__ + "img/Res-yellow.a60a234a.png";